import styled from 'styled-components';


export const HomeWrapper = styled.div`
    overflow: hidden;
    width: 960px;
    margin: 0 auto;
`;

export const HomeLeft = styled.div`
    float: left;
    margin-left: 15px;
    padding-top: 30px;
    width: 625px;
    .banner-img {
      width: 625px;
      height: 300px;
      background-size: contain;
    }
`;

export const HomeRight = styled.div`
    width: 280px;
    float: right;
`;

export const TopicWrapper = styled.div`
  overflow: hidden;
  padding: 20px 0 10px 0;
  margin-left: -18px;
  border-bottom: 1px solid #dcdcdc;
`;

export const TopicItem = styled.div`
    float: left;
    height: 32px;
    line-height: 32px;
    margin-left: 18px;
    margin-bottom: 18px;
    padding-right: 10px;
    background: #f7f7f7;
    font-size: 14px;
    color: #000;
    border: 1px solid #dcdcdc;
    border-radius: 4px;
    .topic-pic {
      display: block;
      float: left;
      width: 32px;
      height: 32px;
      margin-right: 10px;
    }
`;

export const ListItem = styled.div`
    overflow: hidden;
    padding: 20px 0;
    border-bottom: 1px solid #dcdcdc;
    .pic {
      display: block;
      width: 125px;
      height: 100px;
      float: right;
      border-radius: 10px;
    }
`;

export const ListInfo = styled.div`
    width: 500px;
    float: left;
    .title {
      line-height: 27px;
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
    .description {
      line-height: 24px;
      font-size: 13px;
      color: #999;
    }
`;

export const RecommendWrapper = styled.div`
    margin: 30px 0;
    width: 280px;

`;

export const RecommendItem = styled.div`
    width: 280px;
    height: 90px;
    background: url(${(props) => props.imgUrl});
    background-size: cover;
    margin: 10px;
`;

export const WriterWrapper = styled.div`
    width: 278px;
    // border: 1px solid #dcdcdc;
    // border-radius: 3px;
    height: 300px;
    // text-align: center; 
`;

export const WriterBar = styled.div`
    padding: 15px 0 15px 0;
    width: 278px;
    height: 18px;
    float: left;
    font-size: 14px;
    color: #999;
    .left-text {
      float: left;
    };
    .right-text {
      float: right;
    }
    .iconfont {
      margin-right: 5px;
    }
`;

export const WriterItem = styled.div`
    overflow: hidden;
    margin: 15px 0 15px 0;
    // margin-top: 15px;
    width: 278px;
    height: 50px;
    font-size: 12px;
    .profile-pic {
      display: block;
      float: left;
      border-radius: 24px;
      margin-right: 10px;
      cursor: pointer;
    };
    .follow {
      float: right;
      margin-top: 5px;
      font-size: 13px;
      color: #1fad8c;
      cursor: pointer;
    }
`;

export const WriterInfo = styled.div`
    margin-top: 0;
    float: left;
    .name {
      line-height: 20px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
    };
    .description {
      line-height: 20px;
      font-size: 12px;
      color: #969696;
      margin-bottom: 5px;
    };
`;

export const LoadMore = styled.div`
    width: 100%;
    height: 40px;
    line-height: 40px;
    margin: 30px 0;
    background: #f0c987;
    text-align: center;
    border-radius: 20px;
    cursor: pointer;
    box-shadow: 2px 1px 3px #c87c56;

`;

export const BackTop = styled.div`
    position: fixed;
    right: 100px;
    bottom: 30px;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border: 1px solid #efd9ce;
    border-radius: 20px;
    box-shadow: 12px 12px 2px 0.5px #efd9ce;
    font-size: 14px;
    background: #eee;
`;